import request from '@/utils/request'

// 自动保存
export function autoSaveRecording (data) {
  return request({
    url: '/api/call/AutoSaveRecording',
    method: 'post',
    data
  })
}

// 根据电话号码获取电话记录
export function queryRecording (data) {
  return request({
    url: '/api/call/QueryRecording',
    method: 'post',
    data
  })
}

// 增加订单关注
export function addAttention (data) {
  return request({
    url: '/api/call/AddAttention',
    method: 'post',
    data
  })
}

// 取消订单关注
export function cancelAttention (data) {
  return request({
    url: '/api/call/CancelAttention',
    method: 'post',
    data
  })
}